// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponents.layoutComponent.';

const CANCEL_APPLICATION_LINK = `${DOMAIN}cancelApplicationLink`,
  LAYOUT_STEP_TITLES = {
    [AppStatesEnumeration.CHECKOUT_PENDING]: `${DOMAIN}uploadIdFlowTitle`,
  },
  STEP_PROGRESS = `${DOMAIN}stepOfProgress`;

export { CANCEL_APPLICATION_LINK, LAYOUT_STEP_TITLES, STEP_PROGRESS };
